import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { calculaEdad } from './PefilFunction';

export const NotificacionesValid = (respuesta) => {
    Post(`${Url}notificaciones`, "", (resp) => {
        let data = JSON.parse(resp);
        respuesta(data);
    });
}

export const ConsultaPerfil = (id, respuesta) => {
    let Content= {
        id: id
    }

    let quitaNull = (campo) => {
        if(campo === null || campo === "") return "";
        return campo;
    }

    Post(`${Url}cosultPeril`, Content, (resp) => {
        let data = JSON.parse(resp);
        let dataEst = data[0][0];
        let dataDir = data[1][0];
        let dataRepre = data[2][0];
        let dataState = [];
        let dataStateRepre = [];
        let date = new Date (dataEst.f_nac);
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if (day < 10) day = `0${day}`
        if (month < 10) month = `0${month}`

        let edad = ""; 
        calculaEdad (dataEst.f_nac, (respuesta) => {
            edad = respuesta;
        })

        dataState = {
            Cedula: `${dataEst.nacionalidad} ${dataEst.ci}`,
            Pasaporte: quitaNull(dataEst.pasaporte),
            NombreC: `${quitaNull(dataEst.nombre_1)} ${quitaNull(dataEst.nombre_2)} ${quitaNull(dataEst.apellido_1)} ${quitaNull(dataEst.apellido_2)}`,
            Pais: dataEst.pais_name,
            Estado: dataEst.estado_name,
            Ciudad: dataEst.ciudad_name,
            Municipio: dataEst.municipio_name,
            Parroquia: dataEst.parroquia_name,
            FNac: `${day}/${month}/${year}`,
            Edad: edad,
            Etnia: quitaNull(dataEst.etnia),

            PaisDir: dataDir.pais_name,
            EstadoDir: dataDir.estado_name,
            CiudadDir: dataDir.ciudad_name,
            MunicipioDir: dataDir.municipio_name,
            ParroquiaDir: dataDir.parroquia_name,

            Avenida: dataEst.dir_avenida,
            Casa: dataEst.dir_casa,
            Tlf1: dataEst.tlf_hab,
            Tlf2: dataEst.tlf_cel,
            Tlf3: dataEst.tlf_ofic,
        }

        if ((edad[0].edad) < 18){
            dataStateRepre = {
                Cedula: `${quitaNull(dataRepre.nac_repre)} ${quitaNull(dataRepre.id_repre)}`,
                Pasaporte: quitaNull(dataRepre.pasaporte_repre),
                NombreC: `${quitaNull(dataRepre.nombre_1_repre)} ${quitaNull(dataRepre.nombre_2_repre)} ${quitaNull(dataRepre.apellido_1_repre)} ${quitaNull(dataRepre.apellido_2_repre)}`,

                PaisDir: dataRepre.pais_name,
                EstadoDir: dataRepre.estado_name,
                CiudadDir: dataRepre.ciudad_name,
                MunicipioDir: dataRepre.municipio_name,
                ParroquiaDir: dataRepre.parroquia_name,
                Avenida: dataRepre.dir_avenida_repre,
                Casa: dataRepre.dir_casa_repre,
                Email: dataRepre.email_repre,
                Tlf1: dataRepre.tlf_hab_repre,
                Tlf2: dataRepre.tlf_cel_repre,
                Tlf3: dataRepre.tlf_ofic_repre,
            }
            respuesta([dataState, dataStateRepre]);
        }else{
            respuesta([dataState]);
        }

    });
}

export const AprobarPerfil = (id, respuesta) => {
    let Content = {
        Id: id
    }

    Post(`${Url}apruebaPerfil`, Content, (resp) => {
        respuesta(resp);
    });
}

export const NoAprobarPerfil = (id, motivo, respuesta) => {
    let Content = {
        Id: id,
        Motivo: motivo
    }

    Post(`${Url}noapruebaPerfil`, Content, (resp) => {
        respuesta(resp);
    });
}


// WEBPACK FOOTER //
// ./src/funciones/NotificacionesFunction.jsx